import { graphql } from 'react-relay'
import { useForm, useMutationBasedFormSubmitHandlers, useFormValidator } from 'hooks/form'
import { FormErrors, GraphQLError } from 'types'
import {
  useSkillSuggestionsForm_CreateCustomSkillMutation,
  useSkillSuggestionsForm_CreateCustomSkillMutation$data,
} from '__generated__/useSkillSuggestionsForm_CreateCustomSkillMutation.graphql'

export interface ISkillSuggestionsFormValues {
  name: string
  industries: { id: string, name: string }[]
}

const validate = (values: ISkillSuggestionsFormValues) => {
  const errors: FormErrors<ISkillSuggestionsFormValues> = {}

  if (!values.name) {
    errors.name = 'Required'
  }

  if (values.industries?.length < 1) {
    errors.industries = 'Required'
  }

  return errors
}

export interface IUseSkillSuggestionsForm {
  onSuccess: (result: useSkillSuggestionsForm_CreateCustomSkillMutation$data, error: Error | GraphQLError | null | undefined, additionalData?: any) => void
}

const useSkillSuggestionsForm = ({ onSuccess }: IUseSkillSuggestionsForm) => {
  const defaultValues: ISkillSuggestionsFormValues = {
    name: '',
    industries: [],
  }

  const submitHandlers = useMutationBasedFormSubmitHandlers<ISkillSuggestionsFormValues, useSkillSuggestionsForm_CreateCustomSkillMutation>(graphql`
    mutation useSkillSuggestionsForm_CreateCustomSkillMutation($input: CreateCustomSkillInput!) {
      createCustomSkill(input: $input) {
        skill {
          id
          name

          industries {
            id
            name
          }
        }
      }
    }
  `, formData => ({
    input: {
      name: formData.name,
      industryIds: formData.industries?.map(x => x.id) || [],
    },
  }), {
    verifySuccess: result => Boolean(result?.createCustomSkill?.skill?.name),
    successMessage: 'Skill successfully created. Refresh the page to use it',
    onSuccess,
  })

  return useForm<ISkillSuggestionsFormValues, useSkillSuggestionsForm_CreateCustomSkillMutation>({
    submitHandlers,
    resolver: useFormValidator(validate),
    defaultValues,
  })
}

export default useSkillSuggestionsForm
